export const APP = 'interactive_tutorial';
export const CRED = 'egdxpZGTu:54c431d1-6a44-44b8-b84a-e46c4fed2de6';
export const URL = 'https://scalr.api.appbase.io';
export const TYPE = 'new-book-search';
